
const WarningAlert = ({ message }) => {
  return (
    <div
      className="alert alert-warning d-flex align-items-center mt-2"
      role="alert"
    >
      <i className="bx bx-error-circle fs-4 me-2"></i>
      <div>
        <strong>Note:</strong> {message}
      </div>
    </div>
  );
};

export default WarningAlert;
